/**
 * Visual tokens for the property "control room" dashboard (October 2026
 * rebuild). Brand colours come from AppThemeConfig; these are the few derived
 * values every dashboard card shares, kept in one place so the cards read as
 * one system.
 */
export const DASH = {
  teal: "#004B4C",
  tealDark: "#003637",
  tealTint: "rgba(0,75,76,0.06)",
  tealTint2: "rgba(0,75,76,0.10)",
  peach: "#fcede2",
  cream: "#fcf2ec",
  gold: "#fbbe68",
  green: "#2e7d32",
  greenTint: "rgba(46,125,50,0.10)",
  amber: "#b26a00",
  amberTint: "rgba(251,190,104,0.22)",
  red: "#c62828",
  redTint: "rgba(198,40,40,0.08)",
  border: "rgba(0,75,76,0.12)",
  muted: "rgba(38,38,38,0.64)",
  cardShadow: "0 1px 2px rgba(0,40,41,0.04), 0 6px 20px rgba(0,40,41,0.06)",
  radius: "16px",
} as const;

/** The shared card surface. */
export const cardSx = {
  bgcolor: "#fff",
  border: `1px solid ${DASH.border}`,
  borderRadius: DASH.radius,
  boxShadow: DASH.cardShadow,
} as const;
